// Small progressive enhancement for the article share control.
export default function copyLink() {
    const copyButtons = document.querySelectorAll('[data-copy-link]');

    copyButtons.forEach((button) => {
        button.addEventListener('click', async () => {
            const status = button.parentElement?.querySelector('.tgb-copy-status');

            try {
                await navigator.clipboard.writeText(window.location.href);
                if (status) status.textContent = 'Copied';
            } catch {
                if (status) status.textContent = 'Copy unavailable';
            }
        });
    });
}
